module.exports = __webpack_public_path__ + "static/media/happypigs_sc.bd519feb.png";